import { render, staticRenderFns } from "./GroupSearch.vue?vue&type=template&id=07a35571&scoped=true"
import script from "./GroupSearch.vue?vue&type=script&lang=js"
export * from "./GroupSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a35571",
  null
  
)

export default component.exports